const HALF = 0.5;

/**
 * Converts azimuth (0 to 360 degrees) to slider value (0 to 1)
 * @param azimuth the current azimuth value
 * @param initialAzimuth the predicted azimuth value (to center the slider)
 * @returns slider value from 0 to 1
 */
export const fromAzimuthToSliderValue = (
  azimuth: number,
  initialAzimuth: number,
): number => {
  let sliderValue = (initialAzimuth - azimuth) / 360 + HALF;

  sliderValue = ((sliderValue % 1) + 1) % 1;

  return sliderValue;
};

/**
 * Converts slider value (0 to 1) back to azimuth (0 to 360 degrees)
 * @param sliderValue the value from the slider
 * @param initialAzimuth the initial azimuth value to account for offset
 * @returns azimuth value from 0 to 360
 */
export const fromSliderToAzimuthValue = (
  sliderValue: number,
  initialAzimuth: number,
): number => {
  let azimuth = initialAzimuth - 360 * (sliderValue - HALF);

  azimuth = ((azimuth % 360) + 360) % 360;

  return Math.round(azimuth * 1000) / 1000; // Ensure 3 decimal places
};
